import React from 'react';

import {AlertInfo} from 'presentation/components';
import {LoadErrorOrEmptyAlertProps} from './types';

export function LoadErrorOrEmptyAlert({description, title, type}: LoadErrorOrEmptyAlertProps) {
	const isError = type === 'error';

	return (
		<AlertInfo.Root color={isError ? 'error' : 'info'}>
			{title ? <AlertInfo.Title title={title} /> : null}
			<AlertInfo.Description>{description}</AlertInfo.Description>
		</AlertInfo.Root>
	);
}
